export default {
    methods: {
        load_stat() {
            this.$http.get(`/finance/stat`).then((res) => {
                if (res.success) {
                    this.$store.commit("change_state", { name: "stat_finance", value: res.data });
                }
            });
        },
    },
};
